import React, { Component } from 'react';
import { Form, Input, Table } from 'antd';
import './SelectApportionObj.less';

const type = ['全部人员', '部门', '项目'];

class ModalApportion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apportion: [],
    };
  }

  componentDidMount() {
    this.setState({
      apportion: this.props.data,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      apportion: nextProps.data,
    });
  }

  findIndex = (arr, record) => {
    let recordIndex = -1;
    arr.forEach((item, index) => {
      if (item.originUuid === record.originUuid) {
        recordIndex = index;
      }
    });
    return recordIndex;
  };

  handleMouseEnter = record => {
    const { apportion } = this.state;
    const index = this.findIndex(apportion, record);
    apportion[index].isEditable = true;
    this.props.resetApportion(apportion);
  };

  handleMouseLeave = record => {
    const { apportion } = this.state;
    const index = this.findIndex(apportion, record);
    apportion[index].isEditable = false;
    this.props.resetApportion(apportion);
  };

  handlePriceChange = record => {
    return e => {
      const { apportion } = this.state;
      const index = this.findIndex(apportion, record);
      apportion[index].price = e.target.value;
      this.props.resetApportion(apportion);
    };
  };

  handleDelete = record => {
    const { apportion } = this.state;
    const index = this.findIndex(apportion, record);
    apportion.splice(index, 1);
    this.props.onDelete(apportion);
    this.props.setChoooseArr(apportion);
  };

  columns = () => {
    return [
      {
        title: '分摊对象',
        dataIndex: 'originName',
        width: 100,
      },
      {
        title: '类型',
        dataIndex: 'originType',
        render: text => <span>{type[text]}</span>,
        width: 100,
      },
      {
        title: '金额',
        dataIndex: 'price',
        onCell: record => {
          return {
            onMouseEnter: () => this.handleMouseEnter(record),
            onMouseLeave: () => this.handleMouseLeave(record),
          };
        },
        width: 160,
        render: (text, record) => {
          return (
            <div>
              {record.isEditable ? (
                <Input value={text} onChange={this.handlePriceChange(record)} />
              ) : (
                <span>{text}</span>
              )}
            </div>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        width: 60,
        render: (text, record) => <a onClick={() => this.handleDelete(record)}>删除</a>,
      },
    ];
  };

  render() {
    const { apportion } = this.state;
    return (
      <Table
        bordered
        rowKey="originUuid"
        columns={this.columns()}
        dataSource={apportion}
        scroll={{ y: 260 }}
        size="small"
      />
    );
  }
}

export default Form.create()(ModalApportion);



// WEBPACK FOOTER //
// ./src/components/comm/apportion/TableEdit.js